// Theme + font system — applied to :root via CSS variables.

export const FONT_PAIRS = {
  nelum: {
    label: "Nelum",
    serif: "Cormorant Garamond",
    sans: "DM Sans",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=DM+Sans:wght@300;400;500;600;700&display=swap",
  },
  ceylon: {
    label: "Ceylon",
    serif: "Cormorant Garamond",
    sans: "Manrope",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=Manrope:wght@200;300;400;500;600;700&display=swap",
  },
  kandy: {
    label: "Kandy",
    serif: "Fraunces",
    sans: "DM Sans",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300..700;1,9..144,300..500&family=DM+Sans:wght@300;400;500;600;700&display=swap",
  },
  colombo: {
    label: "Colombo",
    serif: "Playfair Display",
    sans: "Karla",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..800;1,400..700&family=Karla:wght@300;400;500;600;700&display=swap",
  },
  galle: {
    label: "Galle",
    serif: "EB Garamond",
    sans: "Jost",
    googleFontsUrl:
      "https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..700;1,400..600&family=Jost:wght@300;400;500;600;700&display=swap",
  },
};

// Themes — HSL tokens matching Tailwind CSS variables in index.css.
export const THEMES = {
  ember: {
    label: "Ember",
    swatch: "#b56b3d",
    tokens: {
      background: "0 0% 5%",
      foreground: "40 20% 90%",
      card: "30 11% 7%",
      "card-foreground": "40 20% 90%",
      popover: "30 11% 7%",
      "popover-foreground": "40 20% 90%",
      primary: "22 55% 49%",
      "primary-foreground": "40 20% 96%",
      secondary: "30 11% 12%",
      "secondary-foreground": "40 20% 90%",
      muted: "30 11% 12%",
      "muted-foreground": "40 10% 62%",
      accent: "30 11% 14%",
      "accent-foreground": "40 20% 90%",
      border: "30 11% 15%",
      input: "30 11% 15%",
      ring: "22 55% 49%",
    },
  },
  midnight: {
    label: "Midnight",
    swatch: "#d4a53a",
    tokens: {
      background: "230 15% 5%",
      foreground: "45 30% 90%",
      card: "230 15% 8%",
      "card-foreground": "45 30% 90%",
      popover: "230 15% 8%",
      "popover-foreground": "45 30% 90%",
      primary: "43 65% 53%",
      "primary-foreground": "230 20% 8%",
      secondary: "230 15% 12%",
      "secondary-foreground": "45 30% 90%",
      muted: "230 15% 12%",
      "muted-foreground": "45 15% 62%",
      accent: "230 15% 14%",
      "accent-foreground": "45 30% 90%",
      border: "230 12% 16%",
      input: "230 12% 16%",
      ring: "43 65% 53%",
    },
  },
  sepia: {
    label: "Sepia",
    swatch: "#d68f4a",
    tokens: {
      background: "24 15% 7%",
      foreground: "35 30% 92%",
      card: "24 15% 10%",
      "card-foreground": "35 30% 92%",
      popover: "24 15% 10%",
      "popover-foreground": "35 30% 92%",
      primary: "28 65% 56%",
      "primary-foreground": "24 20% 10%",
      secondary: "24 15% 14%",
      "secondary-foreground": "35 30% 92%",
      muted: "24 15% 14%",
      "muted-foreground": "35 15% 62%",
      accent: "24 15% 16%",
      "accent-foreground": "35 30% 92%",
      border: "24 12% 18%",
      input: "24 12% 18%",
      ring: "28 65% 56%",
    },
  },
  nelum: {
    label: "Nelum",
    swatch: "#6A5523",
    tokens: {
      // Ceylon Night background · Lotus Cream text · Spice Gold primary
      background: "26 81% 6%",         // #1C0E03 — Ceylon Night
      foreground: "38 62% 90%",        // #F5E9D5 — Lotus Cream
      card: "31 45% 13%",              // #2F2112 — Dark Earth
      "card-foreground": "38 62% 90%",
      popover: "31 45% 13%",
      "popover-foreground": "38 62% 90%",
      primary: "42 50% 40%",           // Spice Gold, lifted for button contrast
      "primary-foreground": "38 62% 92%",
      secondary: "31 40% 15%",
      "secondary-foreground": "38 62% 90%",
      muted: "31 30% 14%",
      "muted-foreground": "43 28% 72%", // Warm Sand — softened
      accent: "31 45% 18%",
      "accent-foreground": "38 62% 90%",
      border: "31 30% 20%",
      input: "31 30% 20%",
      ring: "42 50% 40%",
    },
  },
};

let currentFontLinkId = "nelum-font-link";

export function applyFontPair(key) {
  const pair = FONT_PAIRS[key] || FONT_PAIRS.ceylon;
  // Swap Google Fonts link
  let link = document.getElementById(currentFontLinkId);
  if (!link) {
    link = document.createElement("link");
    link.id = currentFontLinkId;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = pair.googleFontsUrl;
  // Set CSS variables so global styles can pick them up
  document.documentElement.style.setProperty("--font-serif", `"${pair.serif}", serif`);
  document.documentElement.style.setProperty("--font-sans", `"${pair.sans}", system-ui, sans-serif`);
}

export function applyTheme(key) {
  const t = THEMES[key] || THEMES.nelum;
  const root = document.documentElement;
  Object.entries(t.tokens).forEach(([k, v]) => {
    root.style.setProperty(`--${k}`, v);
  });
}

export function applySettings({ font_pair, theme }) {
  if (font_pair) applyFontPair(font_pair);
  if (theme) applyTheme(theme);
}
